import { useMediaQuery } from "@mui/material";
import React from "react";

export interface ResponsiveFilterGridProps {
  children: React.ReactNode;
  minColumnWidth?: number;
  gap?: number;
  mobileBreakpointQuery?: string;
  style?: React.CSSProperties;
}

export const ResponsiveFilterGrid = ({
  children,
  minColumnWidth = 220,
  gap = 16,
  mobileBreakpointQuery = "(max-width: 768px)",
  style,
}: ResponsiveFilterGridProps) => {
  const isMobile = useMediaQuery(mobileBreakpointQuery);

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: isMobile
          ? "1fr"
          : `repeat(auto-fit, minmax(${minColumnWidth}px, 1fr))`,
        gap,
        width: "100%",
        ...style,
      }}
    >
      {children}
    </div>
  );
};
